var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed, observable } from "mobx";
export class AcceptInviteManager {
    constructor(authManager, organizationsManager, routingUIManager) {
        this.authManager = authManager;
        this.organizationsManager = organizationsManager;
        this.routingUIManager = routingUIManager;
        this.authManager = authManager;
        this.inviteSecret = null;
        this.inviteContractAddress = null;
    }
    setInviteStatus(status) {
        if (status) {
            this.setInvitePending();
        }
        else {
            this.setInviteNotPending();
        }
    }
    setInvitePending() {
        var _a, _b;
        if (!((_a = this.inviteFromUrlParams) === null || _a === void 0 ? void 0 : _a.secret) || !((_b = this.inviteFromUrlParams) === null || _b === void 0 ? void 0 : _b.contractAddress)) {
            console.log("no invite params");
            return;
        }
        this.inviteSecret = this.inviteFromUrlParams.secret;
        this.inviteContractAddress = this.inviteFromUrlParams.contractAddress;
        console.log("invite params set", this.inviteSecret, this.inviteContractAddress);
    }
    setInviteNotPending() {
        this.inviteSecret = null;
        this.inviteContractAddress = null;
    }
    get inviteParams() {
        console.log("invite params method", this.inviteSecret, this.inviteContractAddress);
        if (!this.inviteSecret || !this.inviteContractAddress) {
            return null;
        }
        return { secret: this.inviteSecret, contractAddress: this.inviteContractAddress };
    }
    async acceptInvite() {
        if (!this.inviteSecret || !this.inviteContractAddress) {
            console.log("no invite params");
            return;
        }
        await this.organizationsManager.acceptInvite(this.inviteContractAddress, this.inviteSecret);
        this.setInviteStatus(false);
    }
    get inviteFromUrlParams() {
        var _a, _b;
        const secret = (_a = this.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.inviteSecret;
        const contractAddress = (_b = this.routingUIManager.currentRouteParams) === null || _b === void 0 ? void 0 : _b.inviteContractAddress;
        console.log("user invite code", secret, contractAddress);
        if (secret && contractAddress) {
            return { secret, contractAddress };
        }
        return null;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AcceptInviteManager.prototype, "inviteSecret", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AcceptInviteManager.prototype, "inviteContractAddress", void 0);
__decorate([
    observable,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AcceptInviteManager.prototype, "setInviteNotPending", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AcceptInviteManager.prototype, "inviteParams", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AcceptInviteManager.prototype, "inviteFromUrlParams", null);
